import React from "react"
import styled from "styled-components"

const menuData = [0, 1, 2, 3]
const delay = 5000

function Slider1() {
  const [index, setIndex] = React.useState(0)
  const timeoutRef = React.useRef(null)

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
  }

  React.useEffect(() => {
    resetTimeout()
    timeoutRef.current = setTimeout(
      () => setIndex((prevIndex) => (prevIndex === menuData.length - 1 ? 0 : prevIndex + 1)),
      delay,
    )
    return () => {
      resetTimeout()
    }
  }, [index])

  return (
    <Container>
      <Wrapper>
        <Slideshow>
          <SlideshowSlider
            style={{ transform: `translate3d(${-index * (100 / menuData.length)}%, 0, 0)` }}
            slideCount={menuData.length}
            >
            <Slide>
              <SlideDetails>
                <ImageContainer>
                  <Image
                    src={"assets/images/healthcare.png"}
                    alt="Healthcare professional"
                  />
                  <ImageOverlay />
                </ImageContainer>
                <ContentContainer>
                  <TextContent>
                    <Heading>Secure Health Records</Heading>
                    <Text>
                      Are you tired of the hassle of carrying paper copies of your medical records? Now there's
                      FootprintID®, a membership service that makes it easy to safely and securely store your personal
                      health information for when you're at home or on the go.
                    </Text>
                  </TextContent>
                </ContentContainer>
              </SlideDetails>
            </Slide>
            <Slide>
              <SlideDetails>
                <ImageContainer>
                  <Image
                    src={"assets/images/medicalteamhospital.png"}
                    alt="Team of nurses"
                  />
                  <ImageOverlay />
                </ImageContainer>
                <ContentContainer>
                  <TextContent>
                    <Heading>Peace of Mind</Heading>
                    <Text>
                      A personal portable health record gives you and your family the peace of mind that comes from
                      knowing you have access to your most important health information anytime and anywhere.
                    </Text>
                  </TextContent>
                </ContentContainer>
              </SlideDetails>
            </Slide>
            <Slide>
              <SlideDetails>
                <ImageContainer>
                  <Image
                    src={"assets/images/nursing.jpg"}
                    alt="Nurse with patient"
                  />
                  <ImageOverlay />
                </ImageContainer>
                <ContentContainer>
                  <TextContent>
                    <Heading>Accessible Anywhere</Heading>
                    <Text>
                      A personal portable health record gives you and your family the peace of mind that comes from
                      knowing you have access to your most important health information anytime and anywhere.
                    </Text>
                  </TextContent>
                </ContentContainer>
              </SlideDetails>
            </Slide>
            <Slide>
              <SlideDetails>
                <ImageContainer>
                  <Image
                    src={"assets/images/nurses.jpg"}
                    alt="Healthcare team"
                  />
                  <ImageOverlay />
                </ImageContainer>
                <ContentContainer>
                  <TextContent>
                    <Heading>Advanced Technology</Heading>
                    <Text>
                      Our unique member service and proprietary technology is designed to help you and your loved ones
                      prepare for travel, obtain better care, and communicate with emergency responders.
                    </Text>
                  </TextContent>
                </ContentContainer>
              </SlideDetails>
            </Slide>
          </SlideshowSlider>
        </Slideshow>
      </Wrapper>

      <NavigationContainer>
        <SlideshowDots>
          {menuData?.map((_, idx) => (
            <Dot key={idx} $active={index === idx} onClick={() => setIndex(idx)} />
          ))}
        </SlideshowDots>

      </NavigationContainer>
    </Container>
  )
}

const Container = styled.div`
  margin: 0 auto;
  padding: 2rem 0px;
  
  @media (max-width: 768px) {
    padding: 0px;
  }
`

const Wrapper = styled.div`
  height: 400px;
  margin: 0 auto;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(248, 250, 252, 0.9));
  backdrop-filter: blur(20px);
  border: 1px solid rgba(6, 71, 108, 0.1);
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 
    0 20px 40px rgba(6, 71, 108, 0.08),
    0 8px 16px rgba(6, 71, 108, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(6, 71, 108, 0.2), transparent);
  }

  @media (max-width: 915px) {
    height: auto;
    min-height: 500px;
  }
  
  @media (max-width: 435px) {
    height: auto;
    min-height: 450px;
    border-radius: 20px;
  }
`

const Slideshow = styled.div`
  margin: 0 auto;
  overflow: hidden;
  height: 100%;
  position: relative;
`

const SlideshowSlider = styled.div`
  display: flex;
  transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  height: 100%;
  width: ${(props) => props.slideCount * 100}%;
`

const Slide = styled.div`
  flex: 0 0 ${(props) => 100 / 4}%;
  width: ${(props) => 100 / 4}%;
  height: 100%;
  position: relative;
  overflow: hidden;
`

const SlideDetails = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.8fr;
  height: 100%;
  align-items: center;

  @media (max-width: 1165px) {
    grid-template-columns: 1fr 1.6fr;
  }
  
  @media (max-width: 915px) {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0rem 0;
  }
`

const ImageContainer = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  @media (max-width: 915px) {
    border-radius: 20px;
  }
`

const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(6, 71, 108, 0.1) 0%,
    rgba(6, 71, 108, 0.05) 50%,
    transparent 100%
  );
  pointer-events: none;
`

const Image = styled.img`
  width: 100%;
  height: 400px;
  object-fit: cover;
  object-position: center;
  border-radius: 24px 0 0 24px;
  transition: transform 0.3s ease;

  @media (max-width: 915px) {
    border-radius: 20px;
    height: 450px;
    margin: 0 auto;
    max-width: 100%;
  }
  
  @media (max-width: 380px) {
    height: 240px;
  }
`

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 3rem;

  @media (max-width: 915px) {
    padding: 0 2rem;
  }
  
  @media (max-width: 435px) {
    padding: 0 1.5rem;
  }
`

const TextContent = styled.div`
`

const Heading = styled.h2`
  color: #06476c;
  font-size: 2.25rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  letter-spacing: -0.025em;

  @media (max-width: 1280px) {
    font-size: 2rem;
  }
  
  @media (max-width: 1080px) {
    font-size: 1.875rem;
  }
  
  @media (max-width: 915px) {
    font-size: 1.75rem;
    text-align: center;
    margin-bottom: 1rem;
  }
  
  @media (max-width: 435px) {
    font-size: 1.5rem;
  }
`

const Text = styled.p`
  color: #374151;
  line-height: 1.7;
  font-size: 1.125rem;
  font-weight: 400;
  margin: 0;
  letter-spacing: 0.01em;

  @media (max-width: 1280px) {
    font-size: 1rem;
    line-height: 1.6;
  }
  
  @media (max-width: 1080px) {
    font-size: 0.95rem;
  }
  
  @media (max-width: 915px) {
    text-align: center;
    font-size: 1rem;
    margin-bottom: 16px;
  }
  
  @media (max-width: 435px) {
    font-size: 0.9rem;
    line-height: 1.6;
  }
`

const NavigationContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`


 const SlideshowDots = styled.div`
   text-align: center;
   padding-top: 22px;
   display: flex;
   justify-content: center;
   align-items: center;
   gap: 10px;
  
   @media (max-width: 1200px) {
     padding-top: 0px;
   }
 `;

const Dot = styled.button`
  padding: 6px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  background: ${(props) => (props.$active ? "linear-gradient(135deg, #06476c, #0891b2)" : "rgba(6, 71, 108, 0.2)")};
  transform: ${(props) => (props.$active ? "scale(1.2)" : "scale(1)")};
  box-shadow: ${(props) =>
    props.$active
      ? "0 4px 12px rgba(6, 71, 108, 0.3), 0 2px 4px rgba(6, 71, 108, 0.2)"
      : "0 2px 4px rgba(6, 71, 108, 0.1)"};

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: transparent;
    transition: all 0.3s ease;
  }
  
  &:hover {
    background: ${(props) => (props.$active ? "linear-gradient(135deg, #06476c, #0891b2)" : "rgba(6, 71, 108, 0.4)")};
    transform: scale(1.3);
    box-shadow: 0 6px 16px rgba(6, 71, 108, 0.25);
    
    &::before {
      background: rgba(6, 71, 108, 0.1);
    }
  }

  &:active {
    transform: scale(1.1);
  }

  @media (max-width: 480px) {
    width: 10px;
    height: 10px;
  }
`



export default Slider1
